<div class="label mobile" [style.background]="color" [class.small]="size === 'sm'" [class.outlined]="!color">
    {{ text }}
</div>
